import React from 'react';
import classNames from 'classnames';

import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import { SOCIAL_LOGINS } from 'rebook/apps/users/constants';
import mainStyles from 'rebook/apps/users/views/UserSettingsView/style.scss';

import styles from './style.scss';


const getAccountBindingStatus = (provider, socialAuth) => {
  if (!socialAuth) {
    return false;
  }
  const bindedAccount = socialAuth.filter((item) => item.provider === provider);
  return bindedAccount && bindedAccount.length > 0;
};

const UserSettingsLitres = ({ user, unbindSocialNetwork, isLoading }) => {
  const { social_auth: socialAuth } = user;
  const litresLogin = SOCIAL_LOGINS.litres;
  const isBound = getAccountBindingStatus(litresLogin.provider, socialAuth);
  const showLoader = isLoading && user.unboundProvider === litresLogin.provider;
  return (
    <div className={classNames(mainStyles.billetContainer, styles.litresSettings)}>
      <div className="title-2">Подключение ЛитРес</div>
      <div className={styles.litresSettingsButton}>
        {isBound && !showLoader && (
          <a className={classNames(styles.litresLogin, `theme-litres-bg`, 'jest-litres-is-bound')}
            onClick={(e) => { unbindSocialNetwork(e, litresLogin.provider); }}>
            <span className={styles.litresLoginIcon}>{litresLogin.icon}</span>
            <span className={styles.litresLoginStatus}>
              Отключить
            </span>
          </a>
        )}
        {isBound && showLoader && (
          <a className={classNames(styles.litresLogin, `theme-litres-bg`, 'jest-litres-binding-loader')}>
            <span className={styles.litresLoginIcon}>{litresLogin.icon}</span>
            <span>
              <SpinnerLoader theme="themePassive" width={'16px'} height={'16px'} />
            </span>
          </a>
        )}
        {!isBound && (
          <a href={`${litresLogin.url}?next=/account/edit/`}
            className={classNames(styles.litresLogin, `theme-litres-bg`, 'jest-litres-is-not-bound')}>
            <span className={styles.litresLoginIcon}>{litresLogin.icon}</span>
            <span className={styles.litresLoginUnboundStatus}>Подключить</span>
          </a>
        )}
      </div>
      <div className={styles.litresSettingsDescription}>
        <span>Книги, которые вы купили в ЛитРес, будут доступны вам в MyBook даже без подписки</span>
      </div>
    </div>
  );
};


export default UserSettingsLitres;
